var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.label)?_c('span',{staticClass:"tag is-rounded ml-2",class:_setup.isCvz ? 'is-warning' : 'is-light',attrs:{"title":_setup.title}},[_vm._v(" "+_vm._s(_setup.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }